var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height px-12"},[_c('v-responsive',{staticClass:"align-start text-center fill-height pa-1"},[_c('router-view',{staticClass:"pb-3 flex-grow-1",staticStyle:{"max-width":"1920px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }